import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'searchAllPaperflow'
})
export class SearchAllPaperflowPipe implements PipeTransform {

  transform(certList: any, value: string): any {
    if (!certList || value === null || value === '') {
      return certList;
    }
    return certList.filter(item =>
      this.changeToBlank(item.certificateID).indexOf(this.changeToBlank(value)) !== -1 ||
      this.changeToBlank(item.employeeID).indexOf(this.changeToBlank(value)) !== -1 ||
      this.changeToBlank(item.typeOfMatch).indexOf(this.changeToBlank(value)) !== -1 ||
      this.changeToBlank(item.verificationResults).indexOf(this.changeToBlank(value)) !== -1
    );
  }

  changeToBlank(value) {
    if (value === null) {
      return '';
    }
    return value.toLowerCase().trim();
  }

}



// WEBPACK FOOTER //
// ./src/app/pipes/search-all-paperflow.pipe.ts